module.exports = __webpack_public_path__ + "img/caja.1b8ba605.svg";